import { Singleton } from "../di/index.js";
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : null === desc ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
class FocusTrapService {
    trap(container, options = {}) {
        const listener = (event)=>{
            if (options.isActive && !options.isActive()) return;
            if ('Escape' === event.key) return void options.onEscape?.();
            if ('Tab' !== event.key) return;
            const focusableElements = this.getFocusableElements(container, options.focusableSelector);
            if (0 === focusableElements.length) return;
            const firstFocusableElement = focusableElements[0];
            const lastFocusableElement = focusableElements[focusableElements.length - 1];
            if (event.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    event.preventDefault();
                }
                return;
            }
            if (document.activeElement === lastFocusableElement) {
                firstFocusableElement.focus();
                event.preventDefault();
            }
        };
        container.addEventListener('keydown', listener);
        return ()=>{
            container.removeEventListener('keydown', listener);
        };
    }
    focusFirst(container, options = {}) {
        const explicitTarget = this.resolveInitialFocus(container, options.initialFocus);
        const focusTarget = explicitTarget || this.getFocusableElements(container, options.focusableSelector)[0];
        focusTarget?.focus();
    }
    getFocusableElements(container, selector = this.defaultSelector) {
        return Array.from(container.querySelectorAll(selector)).filter((element)=>!this.isDisabled(element) && this.isVisible(element));
    }
    resolveInitialFocus(container, initialFocus) {
        if (!initialFocus) return null;
        if ('function' == typeof initialFocus) return initialFocus();
        if ('string' == typeof initialFocus) return container.querySelector(initialFocus);
        return initialFocus;
    }
    isDisabled(element) {
        return 'disabled' in element && Boolean(element.disabled);
    }
    isVisible(element) {
        if (element.hasAttribute('hidden') || -1 === element.tabIndex) return false;
        if ('undefined' == typeof window || 'function' != typeof window.getComputedStyle) return true;
        const style = window.getComputedStyle(element);
        return 'none' !== style.display && 'hidden' !== style.visibility;
    }
    constructor(){
        this.defaultSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    }
}
FocusTrapService = _ts_decorate([
    Singleton()
], FocusTrapService);
export { FocusTrapService };
